import { useNavigateToRoute } from './navigateToRouteComposable';
import store from '@/store';
import i18n from '@/language/i18n';
import SNACKBAR_TYPES from "@/utils/enum/SNACKBAR_TYPES";

const QR_CODE_KEY_ENUMS = ['products', 'devices', 'public/devices', 'storageelements'];

export function useQrScannerAndOpenUrl() {
  const { navigateToRoute } = useNavigateToRoute();

  function handleQrScan({ key, id, value }) {

    if (!Object.values(QR_CODE_KEY_ENUMS).includes(key)) {
      store.dispatch('globalSnackbarStore/showSnackbarWithMessage', {
        type: SNACKBAR_TYPES.ERROR,
        message: i18n.t('MobileDeviceBridge.sentences.qrCodeNoInformation')
      });
      return;
    }

    if (key === 'storageelements') {
      navigateToRoute({ name: 'StockForm', params: { id } });
      return;
    }

    let path = new URL(value);
    const params = new URLSearchParams(path.search);
    const queryParams = {}; 
    params.forEach((value, key) => { queryParams[key] = value; });

    navigateToRoute({ path: path.pathname, query: queryParams });
  }

  return { handleQrScan }
};